import { Box, Flex, Tooltip, styled } from "@100mslive/react-ui";
import { Fragment, useContext, useEffect, useState } from "react";
import {
  selectIsAllowedToPublish,
  useHMSStore,
  useScreenShare,
} from "@100mslive/react-sdk";

import { FEATURE_LIST } from "../common/constants";
import IconButton from "../IconButton";
import { LiveHodoContext } from "../contexts/LiveHodoContext";
import { MusicIcon } from "@100mslive/react-icons";
import { ScreenShareHintModal } from "./ScreenshareHintModal";
import { isScreenshareSupported } from "../common/utils";
import { useIsFeatureEnabled } from "./hooks/useFeatures";

export const ScreenshareAudio = ({ css = {} }) => {
  // const {
  //   stateCtx: { isAudioShareDisabled },
  //   setIsScreenShareDisabled,
  // } = useContext(LiveHodoContext);

  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    screenShareAudioTrackId: audio,
    toggleScreenShare,
  } = useScreenShare();
  const isAllowedToPublish = useHMSStore(selectIsAllowedToPublish);
  const isAudioScreenshare = amIScreenSharing && !video && !!audio;
  const [showModal, setShowModal] = useState(false);
  const isFeatureEnabled = useIsFeatureEnabled(
    FEATURE_LIST.AUDIO_ONLY_SCREENSHARE
  );

  // useEffect(() => {
  //   setIsScreenShareDisabled(isAudioScreenshare);
  // }, [isAudioScreenshare]);

  // useEffect(() => {
  //   console.log(isAudioShareDisabled);
  // }, [isAudioShareDisabled]);

  if (
    !isFeatureEnabled ||
    !isAllowedToPublish.screen ||
    !isScreenshareSupported()
  ) {
    return null;
  }

  return (
    <Fragment>
      <Flex direction="row">
        <ScreenShareButton
          variant="standard"
          key="AudioScreenshare"
          active={!isAudioScreenshare}
          css={css}
          onClick={() => {
            if (amIScreenSharing) {
              toggleScreenShare();
            } else {
              setShowModal(true);
            }
          }}
        >
          <Tooltip
            title={`${
              !isAudioScreenshare ? "Bắt đầu" : "Dừng"
            } chia sẻ âm thanh`}
          >
            <Box>
              <MusicIcon />
            </Box>
          </Tooltip>
        </ScreenShareButton>
        {showModal && (
          <ScreenShareHintModal onClose={() => setShowModal(false)} />
        )}
      </Flex>
    </Fragment>
  );
};

const ScreenShareButton = styled(IconButton, {
  h: "$14",
  px: "$8",
  r: "$1",
  borderRadius: "$1",
  // borderTopRightRadius: 0,
  // borderBottomRightRadius: 0,
  "@md": {
    px: "$4",
    mx: 0,
  },
});
